import { createSlice } from "@reduxjs/toolkit";
import { ContactForm, CustomerCare } from "@/utils/types/aem";
import { getContactFormData } from "./actions";

const initialState = {
  isLoading: false,
  isError: false,
  HeaderDescription: {} as string,
  ContactForm: {} as ContactForm,
  SobeysCustomerCare: {} as CustomerCare,
  itemOrder: [] as any,
};

const GetContactFormDataSlice = createSlice({
  name: "contactForm",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getContactFormData.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(getContactFormData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.HeaderDescription =
        action.payload[":items"]["root"][":items"]["container"][":items"][
          "container"
        ][":items"]["text"]["text"];
      state.ContactForm =
        action.payload[":items"]["root"][":items"]["container"][":items"][
          "container"
        ][":items"]["columncontrol"][":items"]["column-1"][":items"][
          "contactform"
        ];
      state.SobeysCustomerCare =
        action.payload[":items"]["root"][":items"]["container"][":items"][
          "container"
        ][":items"]["columncontrol"][":items"]["column-2"][":items"][
          "customercare"
        ];
      state.itemOrder =
        action.payload[":items"]["root"][":items"]["container"][":items"][
          "container"
        ][":items"]["columncontrol"][":itemsOrder"];
    });
    builder.addCase(getContactFormData.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});

export const getContactFormDataSlice = GetContactFormDataSlice.reducer;